export default function AppRun(
  $state,
  $location,
  $rootScope,
  $timeout,
  WhitelabelService,
  MarketplaceService,
  UserCache,
  API,
) {
  'ngInject'

  $rootScope.urlS3 = API.QP2_ASSETS_BUCKET
  $rootScope.VERSION = API.QP2_VERSION
  $rootScope.ENV = API.QP2_ENV
  if (API.QP2_BUILD !== undefined && API.QP2_BUILD.indexOf('.') !== -1) {
    $rootScope.BUILD = API.QP2_BUILD.split('.')[0]
  }
  $rootScope.stateMenu = false

  WhitelabelService.load()

  if ($location.$$path.indexOf('signin') === -1 && $location.$$path.indexOf('signup') === -1) {
    MarketplaceService.list(0, 100).then(function (data) {
      $rootScope.marketplaces = data.results
      localStorage.setItem('marketplaces', JSON.stringify(data.results))
    })
  }

  if (jQuery) {
    var originalFn = $.fn.data
    $.fn.data = function () {
      if (arguments[0] !== '$binding') {
        return originalFn.apply(this, arguments)
      }
    }
  }

  $rootScope.toggleMenu = function () {
    $rootScope.stateMenu = !$rootScope.stateMenu
  }

  $rootScope.resize = function () {
    if (window.innerWidth <= 768) {
      $rootScope.isMobile = true
    } else {
      $rootScope.isMobile = false
    }

    if (window.innerWidth <= 1000) {
      $rootScope.isTablet = true
    } else {
      $rootScope.isTablet = false
    }

    if (!$rootScope.$$phase) {
      $rootScope.$apply()
    }
  }

  $rootScope.logout = function () {
    UserCache.remove()
    $state.go('signin')
  }

  $rootScope.$on('$stateChangeSuccess', function (event, state) {
    $('.sweet-overlay').hide()
    $('.sweet-alert').hide()
    $('.modal-backdrop').remove()
    $('.modal-open').css('overflow', 'initial')
    $(document).on('click', '.navbar-collapse.in', function (e) {
      if ($(e.target).is('a') && $(e.target).attr('class') !== 'dropdown-toggle') {
        $(this).collapse('hide')
      }
    })
    UserCache.get()
    $rootScope.resize()
    if (
      $location.$$path.indexOf('signin') === -1 &&
      $location.$$path.indexOf('signup') === -1 &&
      $location.$$path.indexOf('admin') === -1 &&
      $location.$$path.indexOf('profile') === -1
    ) {
      $timeout(function () {
        $rootScope.assets_bucket = API.QP2_ASSETS_BUCKET
        // $rootScope.logo = publisher['img-logo-l'];
        // $rootScope.name = publisher.t;
      }, 1000)

      switch (state.name) {
        case 'admin.users':
          $rootScope.side = 'admin_users'
          break
        case 'admin.home':
          $rootScope.side = 'admin_home'
          break
        case 'pub.channels':
          $rootScope.side = 'channels'
          break
        case 'pub.channels.sets':
          $rootScope.side = 'sets'
          break
        case 'pub.channels.sets.create':
          $rootScope.side = 'sets'
          break
        case 'pub.channels.sets.edit':
          $rootScope.side = 'sets'
          break
        case 'pub.reviews':
          $rootScope.side = 'sets'
          break
        case 'pub.collectibles' || 'pub.collectibles.create' || 'pub.collectibles.edit':
          $rootScope.side = 'collectibles'
          break
        case 'pub.bundles' || 'pub.bundles.create' || 'pub.bundles.edit':
          $rootScope.side = 'bundles'
          break
        default:
          $rootScope.side = 'channels'
          break
      }
    } else {
      $rootScope.channelName = null
      $rootScope.channelImage = null
    }

    if ($location.$$path.indexOf('signin') === -1 && $location.$$path.indexOf('signup') === -1) {
      if ($location.$$path !== '/') {
        var isAdmin = $location.$$path.indexOf('admin') !== -1
        if (isAdmin) {
          localStorage.setItem('permission', 'admin')
          if ($rootScope.customerService) {
            $rootScope.title = 'Customer Service Portal'
          } else {
            $rootScope.title = 'Administrator Portal'
          }
        } else {
          localStorage.setItem('permission', 'publisher')
          $rootScope.title = 'Publisher Portal'
        }
      }

      var auth = UserCache.getObject()
      if (auth !== undefined) {
        if (auth.user.admin !== undefined && auth.user.producer === undefined) {
          if (auth.user.admin.k === 2) {
            if (state.name.indexOf('admin.profile') === -1) {
              if (
                state.name.indexOf('admin.users') === -1 &&
                state.name.indexOf('admin.posts') === -1
              ) {
                $state.go('admin.home')
              }
            }
          }
        }
      }
    }
  })

  $rootScope.$on('$stateChangeStart', function (event, state) {
    $rootScope.resize()
    $timeout(function () {
      if ($location.$$path.indexOf('signin') === -1 && $location.$$path.indexOf('signup') === -1) {
        $rootScope.publishers = []
        var auth = UserCache.getObject()
        if (auth !== undefined) {
          if (auth.user.admin !== undefined) {
            if (auth.user.admin.k === 2) {
              $rootScope.customerService = true
            } else {
              $rootScope.customerService = false
            }
            $rootScope.admin = true
          } else {
            $rootScope.admin = false
          }
          if (auth.user.admin !== undefined && auth.user.producer === undefined) {
            $rootScope.notProducer = true
          } else {
            $rootScope.notProducer = false
          }

          if (auth.user.producer !== undefined) {
            $rootScope.publishers = [auth.user.producer.pu]
          }
        }
      }
    }, 300)
  })

  function checkPermission() {
    var auth = UserCache.getObject()
    if (auth !== undefined) {
      if (auth.user.admin !== undefined) {
        if (auth.user.admin.k === 2) {
          $rootScope.customerService = true
        } else {
          $rootScope.customerService = false
        }
        $rootScope.admin = true
      } else {
        $rootScope.admin = false
      }
      if (auth.user.admin !== undefined && auth.user.producer === undefined) {
        $rootScope.notProducer = true
      } else {
        $rootScope.notProducer = false
      }

      if (auth.user.producer !== undefined) {
        $rootScope.publishers = [auth.user.producer.pu]
      }
    }
  }

  checkPermission()

  window.onresize = $rootScope.resize

  Array.prototype.remove = function remove(item) {
    var idx = this.indexOf(item)
    if (idx > -1) {
      this.splice(idx, 1)
    }
    return this
  }

  String.prototype.capitalizeFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
  }

  String.prototype.replaceAll = function (needle, replacement) {
    return this.split(needle).join(replacement)
  }
}
